import React, {Component} from "react";
import CmSearchInput from "../../../../../components/CmSearchInput/CmSearchInput";
import {Button, Tooltip, message} from "antd";
import "./menuToolBar.css";
import BaseComponent from "../../../../../base/BaseComponent";

export default class MenuToolBar extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            isUpdateSort: true,// 是否是修改排序
        }
    }

    render() {
        const {
            onSearch,
            searchValue,
            onSearchValueChange,
            showBoundPermission,
            showMenuEdit,
            isRootNode,
        } = this.props;
        const btnStyle = {
            color: this.themeBgColor,
            border: '1px solid rgb(217, 217, 217)',
            borderRadius: '4px',
            height: '32px',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'Center',
            alignItems: 'center',
            cursor:'pointer',
        };
        return (
            <div className="MenuToolBar">
                <div className="MenuToolBar-left">
                    <Button onClick={() => showMenuEdit()} className="margin-right-20" type="primary">添加菜单</Button>
                    <Tooltip placement="right" title={isRootNode() ? "菜单根节点不允许绑定权限" : ""}>
                        <Button disabled={isRootNode()}
                                onClick={() => showBoundPermission()}
                                className="margin-right-20"
                        >
                            <span>绑定权限</span>
                        </Button>
                    </Tooltip>
                    <div style={{...btnStyle, width: '88px'}} className="margin-right-20"
                         onClick={this.sortUpdate}>{this.state.isUpdateSort ? '修改排序' : '保存排序'}</div>
                    {
                        !this.state.isUpdateSort ? <div className="margin-right-20"
                                                       style={{...btnStyle, width: '62px'}}
                                                       onClick={this.sortCancel}>取消
                        </div> : null
                    }
                </div>
                <div className="MenuToolBar-right">
                    <CmSearchInput
                        onSearch={onSearch}
                        searchValue={searchValue}
                        onSearchValueChange={onSearchValueChange}
                        placeholder="请输入关键字"
                    />
                </div>
            </div>
        );
    }
    // 排序按钮改变
    sortUpdate = () => {
        this.state.isUpdateSort = !this.state.isUpdateSort;
        this.setState({}, () => {
            if (this.state.isUpdateSort) {
                this.saveSort()
            } else {
                this.props.sortStatusCall && this.props.sortStatusCall();
            }
        });
    };
    // 取消
    sortCancel = () => {
        this.setState({
            isUpdateSort: true
        },()=>{
            this.props.onSortCall && this.props.onSortCall();
            this.props.sortStatusCall && this.props.sortStatusCall();
        })
    };
    // 保存排序
    saveSort = () => {
        let tableData = this.props.tableData;
        let params = {};
        // 排序后数据组装
        tableData.forEach((item, index) => {
            params[item.id] = item.optionSort
        });
        this.request({
            url: '/cm-sites-sys/menu/updateSort',
            method: 'post',
            contentType: 'json',
            body: params,
            callBack: (res) => {
                message.destroy();
                if (res) {
                    this.props.onSortCall && this.props.onSortCall();
                    this.props.sortStatusCall && this.props.sortStatusCall();
                    message.success('排序保存成功');
                }
            }
        })
    }
}